<app-menu>
  <div class="desktop">
    <app-voltar class="back" />
    <div class="header">
      <app-titulo
        [text]="this.editando ? 'Editar projeto' : 'Cadastrar projeto'"
      ></app-titulo>
      <p>Passo {{ this.etapa }} de {{ this.totalEtapas }}</p>
    </div>
    <div [ngSwitch]="etapa">
      <div *ngSwitchCase="1">
        <form #projetoform="ngForm">
          <app-input
            type="text"
            label="Nome do projeto"
            name="NmProjeto"
            [requiredInput]="true"
            [(ngModel)]="form.NmProjeto"
          ></app-input>
          <app-input
            type="select"
            label="Responsável"
            name="FuncionarioId"
            [requiredInput]="true"
            [(ngModel)]="form.FuncionarioId"
            [selectData]="responsavelOptions"
          ></app-input>
          <div>
            <app-input
              type="select"
              label="Obra relacionada"
              name="ObraId"
              [(ngModel)]="form.ObraId"
              [selectData]="obrasOptions"
              [disabled]="form.FrenteTrabalhoId! > 0"
              [requiredInput]="form.FrenteTrabalhoId! === null"
            ></app-input>
          </div>
          <div>
            <app-input
              type="select"
              label="Fábrica relacionada"
              name="FrenteTrabalhoId"
              [(ngModel)]="form.FrenteTrabalhoId"
              [selectData]="obrasOptions"
              [disabled]="form.ObraId! > 0"
              [requiredInput]="form.ObraId! === null"
            ></app-input>
          </div>
          <app-input
            type="date"
            placeholder="dd/mm/aaaa"
            label="Data de início"
            name="DtInicio"
            [requiredInput]="true"
            [(ngModel)]="form.DtInicio"
          ></app-input>
          <app-input
            type="date"
            placeholder="dd/mm/aaaa"
            label="Data de término"
            name="DtTermino"
            [requiredInput]="true"
            [(ngModel)]="form.DtTermino"
          ></app-input>
          <app-select-adicao
            label="Disciplinas do projeto (selecione pelo menos uma)"
            [selectData]="disciplinaOptions"
            (items)="updateDisciplinas($event)"
            [requiredInput]="true"
            [disabled]="this.editando"
          />
          <div class="disciplinas-list" *ngIf="form.disciplinaList.length > 0">
            <label>Responsável pela disciplina</label>
            <div
              class="disciplinas-list-grid"
              *ngFor="let disciplina of this.form.disciplinaList"
            >
              <span class="disciplinas-list-item">
                {{ disciplina.TxNomeDisciplina }}
              </span>
              <span class="disciplinas-list-item">
                {{ disciplina.TxResponsavelDisciplina }}
              </span>
            </div>
          </div>
        </form>
        <div class="form-buttons">
          <app-botao
            text="{{ this.editando ? 'Editar' : 'Avançar' }}"
            (click)="this.editando ? atualizarProjeto() : proximaEtapa()"
            [disabled]="validarForm() ? false : true"
          ></app-botao>
        </div>
      </div>

      <div *ngSwitchCase="2">
        <form class="form-1fr" #pessoaForm="ngForm">
          <h2 class="subtitle">
            Anexe o PDF do projeto para a validação posterior (Apenas um projeto
            por vez)
          </h2>
          <h2>Envio de arquivos</h2>
          <app-drag-drop-pdf
            label="Projeto"
            text="Arraste para enviar o arquivo"
            acceptedFileType=".pdf"
            [initialFileUrl]="
              editando &&
              form.imagemProjeto &&
              form.imagemProjeto.TxImagemProjeto
                ? form.imagemProjeto.TxImagemProjeto
                : ''
            "
            (fileDropped)="onFileDropped('TxImagemProjeto', $event, 0)"
          ></app-drag-drop-pdf>
        </form>
        <div class="form-buttons-grid">
          <app-botao
            type="secundario"
            text="Anterior"
            (click)="etapaAnterior()"
          ></app-botao>
          <app-botao text="Avançar" (click)="proximaEtapa()"></app-botao>
        </div>
      </div>

      <div *ngSwitchCase="3">
        <form class="form-1fr" #pessoaForm="ngForm">
          <h2 class="subtitle">
            Anexe o PDF do projeto para a validação posterior (Apenas um projeto
            por vez)
          </h2>
          <h2>Envio de arquivos</h2>
          <app-drag-drop-pdf
            *ngFor="let disciplina of this.form.disciplinaList; index as i"
            [label]="disciplina.TxNomeDisciplina.toUpperCase()"
            text="Arraste para enviar o arquivo"
            [initialFileUrl]="
              editando &&
              disciplina.ImagemDisciplina &&
              disciplina.ImagemDisciplina.TxImagemProjetoDisciplina
                ? disciplina.ImagemDisciplina.TxImagemProjetoDisciplina
                : ''
            "
            (fileDropped)="
              onFileDropped(disciplina.TxNomeDisciplina, $event, i)
            "
          ></app-drag-drop-pdf>
        </form>
        <div class="form-buttons-grid">
          <app-botao
            type="secundario"
            text="Anterior"
            (click)="etapaAnterior()"
          ></app-botao>
          <app-botao
            [text]="this.editando ? 'Editar projeto' : 'Cadastrar projeto'"
            (click)="cadastrarProjeto()"
          ></app-botao>
        </div>
      </div>
    </div>
  </div>
</app-menu>

<app-loader *ngIf="loader" />
